import React from 'react';
import { StyledToggleContainer, StyledEditActionContainer } from '../../styles/devices/Container';
// Store
import { EditSchedule } from '../../../../store/rules/types';

export const DevicesToggle = ({ children }: { children?: React.ReactNode }) => {
    return (
      <StyledToggleContainer>
       {children}
      </StyledToggleContainer>
    )
}

export const DisplayDevicesEditSchedules = ({ show, children }: { show: boolean, children?: React.ReactNode }) => {
  return (
    <div>
      {show? children: null}
    </div>
  )
}

export const DevicesEditActions = ({schedule, children}: {schedule: EditSchedule; children?: React.ReactNode}) => {
 
  return (
    <StyledEditActionContainer>
      {schedule.editable? children: null}
    </StyledEditActionContainer>
  )
}

